module.exports = __webpack_public_path__ + "img/cognitive-function-sidebar.4bf87e0c.svg";